import { render, staticRenderFns } from "./TopNavbar.vue?vue&type=template&id=6ba50c8b&"
import script from "./TopNavbar.vue?vue&type=script&lang=js&"
export * from "./TopNavbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports